import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';
import { CAESAR_OPCIOK } from '../caesar.opciok';

@Component({
  selector: 'app-caesar-ugytipusok',
  templateUrl: './ugytipusok.component.html',
  styleUrls: ['./ugytipusok.component.scss'],
})
export class UgytipusokComponent implements OnInit {
  @ViewChild('tipusModal') tipusModal: IonModal;
  opciok = CAESAR_OPCIOK;
  intezmeny = '';
  tipusok: any[] = [];
  szerk: any = null;
  ev = new Date().getFullYear();
  mappaInfo: any = null;     // hibrid mappa-ellenőrzés eredménye a modálban
  desktop = !!(window as any).cronom?.desktop;  // telepített app? (natív mappaválasztó elérhető)

  // Csak a főkategóriák (nincs szülőjük) – ezek alá kerülnek az alkategóriák.
  get fokategoriak() { return (this.tipusok || []).filter((t) => !t.szulo_id); }
  alkategoriak(foId: string) { return (this.tipusok || []).filter((t) => t.szulo_id === foId); }
  // A modálban választható szülők: valódi főkategóriák, önmagát kizárva.
  szuloOpciok() { return this.fokategoriak.filter((t) => t.id !== this.szerk?.id); }
  // Eredő betűjel: alkategóriánál a FŐ betűjele + az al betűjele (pl. "B" + "L" = "BL").
  kombinaltBetujel(t: any) {
    if (!t) return '';
    if (!t.szulo_id) return t.elotag || '';
    const fo = (this.tipusok || []).find((x) => x.id === t.szulo_id);
    return (fo?.elotag || '') + (t.elotag || '');
  }

  constructor(private http: HttpClient, private data: DataService, private toast: ToastController, private alert: AlertController) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    await this.betolt();
  }

  async betolt() {
    try { this.tipusok = await firstValueFrom(this.http.get<any[]>('/api/caesar/ugytipusok/' + this.intezmeny)); }
    catch { this.hiba('Nem sikerült betölteni az ügytípusokat.'); }
  }

  uj() {
    this.mappaInfo = null;
    this.szerk = { intezmeny: this.intezmeny, nev: '', elotag: '', szulo_id: null, szamformatum: 'sorszam/ev', aktiv: true, sorrend: 0, mappa: '', mappa_struktura: 'ugy' };
    this.tipusModal.present();
  }
  // Új alkategória egy adott főkategóriához (előre kitöltött szülővel + örökölt formátummal).
  ujAl(fo: any) {
    this.mappaInfo = null;
    this.szerk = { intezmeny: this.intezmeny, nev: '', elotag: '', szulo_id: fo.id,
      szamformatum: fo.szamformatum || 'sorszam/ev', aktiv: true, sorrend: 0, mappa: '', mappa_struktura: 'ugy' };
    this.tipusModal.present();
  }
  szerkeszt(t: any) {
    this.mappaInfo = null;
    this.szerk = { ...t, aktiv: !!t.aktiv, intezmeny: this.intezmeny, mappa: t.mappa || '', mappa_struktura: t.mappa_struktura || 'ugy' };
    this.tipusModal.present();
  }

  // Natív mappaválasztó (csak telepített appban): a kiválasztott útvonalat beírja és ellenőrzi.
  async tallozMappa() {
    const pf = (window as any).cronom?.pickFolder;
    if (!pf) return;
    const p = await pf({ title: 'Ügytípus helyi gyökérmappája', defaultPath: this.szerk?.mappa || undefined });
    if (p) { this.szerk.mappa = p; await this.mappaEllenoriz(); }
  }

  // Hibrid: a megadott helyi mappa ellenőrzése (létezik-e, hány ügymappa lenne benne).
  async mappaEllenoriz() {
    const utvonal = String(this.szerk?.mappa || '').trim();
    if (!utvonal) { this.mappaInfo = null; return; }
    try {
      this.mappaInfo = await firstValueFrom(this.http.post('/api/caesar/hibrid/mappa-ellenoriz',
        { utvonal, struktura: this.szerk.mappa_struktura }));
    } catch (e: any) { this.mappaInfo = null; this.hiba(e?.error?.error || 'Csak a helyi alkalmazásban ellenőrizhető.'); }
  }

  async mentes() {
    if (!this.szerk?.nev?.trim()) return this.hiba('A név kötelező.');
    this.szerk.intezmeny = this.intezmeny;
    try {
      if (this.szerk.id) await firstValueFrom(this.http.put('/api/caesar/ugytipus/' + this.szerk.id, this.szerk));
      else await firstValueFrom(this.http.post('/api/caesar/ugytipus', this.szerk));
      await this.tipusModal.dismiss();
      await this.betolt();
      this.ok('Mentve.');
    } catch { this.hiba('Nem sikerült menteni.'); }
  }

  async torol(t: any) {
    const a = await this.alert.create({
      header: 'Törlés', message: `Biztosan törli: ${t.nev}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, {
        text: 'Törlés', role: 'destructive', handler: async () => {
          try { await firstValueFrom(this.http.delete('/api/caesar/ugytipus/' + t.id)); await this.betolt(); this.ok('Törölve.'); }
          catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
        }
      }],
    });
    a.present();
  }

  cimke(lista: any[], v: string) { return lista.find((x) => x.value === v)?.label || v || ''; }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1800, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2500, color: 'danger' })).present(); }
}
